export enum ContactFindTypeRestriction {
  None = 0,
  Purchasers = 1,
  PropertyOwners = 2,
  Tenants = 3,
}
